export default function Hero() {
  return (
    <section id="home" className="relative flex min-h-[620px] w-full items-center overflow-hidden md:min-h-[680px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Fresh%20vibrant%20watermelon%20slices%20with%20green%20rind%20on%20a%20clean%20bright%20cream%20background%2C%20juicy%20red%20pink%20flesh%20with%20dark%20seeds%2C%20soft%20natural%20lighting%2C%20refreshing%20summer%20food%20photography%2C%20minimal%20styling%2C%20warm%20and%20inviting%20tone%2C%20high%20detail%20commercial%20photo&width=1800&height=1000&seq=chigua-hero-2026x1&orientation=landscape"
          alt="新鲜的西瓜与绿色瓜皮"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/80 to-background-50/40" />
      </div>

      <div className="relative mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-6 px-4 py-24 md:px-6 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-300 bg-accent-100 px-4 py-1.5 text-sm font-medium text-accent-800">
            <i className="ri-sparkling-line" />
            多地址互换参考 · 随手存好备用
          </span>
          <h1 className="mt-6 text-3xl font-black leading-snug text-foreground-950 text-balance md:text-5xl">
            吃瓜网址怎么选？
            <br />
            多地址互换
            <span className="text-primary-600">不吃亏</span>
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
            网址备用几个、主站打不开先切哪个、可用检测怎么判断哪个能开——
            这里把吃瓜网址多个地址的互换逻辑一次讲清，顺手存好，追更不断档。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#address"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-base font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              查看地址汇总
              <i className="ri-arrow-down-line ml-2" />
            </a>
            <a
              href="#switch"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-full border border-background-300 bg-background-50/80 px-7 py-3.5 text-base font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              学互换方法
            </a>
          </div>
          <dl className="mt-10 grid max-w-md grid-cols-3 gap-4">
            <div className="rounded-xl bg-background-50/70 p-3 text-center backdrop-blur-sm">
              <dt className="text-xs text-foreground-600">备用入口</dt>
              <dd className="mt-1 text-xl font-bold text-primary-700 md:text-2xl">5+</dd>
            </div>
            <div className="rounded-xl bg-background-50/70 p-3 text-center backdrop-blur-sm">
              <dt className="text-xs text-foreground-600">同步频率</dt>
              <dd className="mt-1 text-xl font-bold text-primary-700 md:text-2xl">实时</dd>
            </div>
            <div className="rounded-xl bg-background-50/70 p-3 text-center backdrop-blur-sm">
              <dt className="text-xs text-foreground-600">可用检测</dt>
              <dd className="mt-1 text-xl font-bold text-primary-700 md:text-2xl">每周</dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
}